import { useEffect, useState } from 'preact/hooks';
import { useTranslation } from 'react-i18next';

import useSearchForm from 'hooks/useSearchForm';
import { Button, Input, Text } from 'components/LoginComponents';
import { useFocus } from 'contexts/FocusContext';
import { CustomText } from 'components/CustomText';

interface RetrySearchFormProps {
  messageSearchForm?: string;
}

const RetrySearchForm = ({
  messageSearchForm: messageSearchFormProp,
}: RetrySearchFormProps): JSX.Element => {
  const { t } = useTranslation();
  const { resetFocus, setFocusOnNextView } = useFocus();
  const {
    formFields,
    initRetrySearchForm,
    onChangeSearchForm,
    onSubmitSearchForm,
    onSearchBySearchTerms,
  } = useSearchForm();

  const messageSearchForm =
    messageSearchFormProp || t('NO_INFORMATION_MESSAGE_2');
  const [hasFormChanged, setHasFormChanged] = useState(false);

  useEffect(() => {
    initRetrySearchForm();
  }, []);

  const handleChange = (event: Event) => {
    setHasFormChanged(true);
    onChangeSearchForm(event);
  };

  const handleSubmit = async (event: Event) => {
    event.preventDefault();

    if (hasFormChanged) {
      resetFocus();
    }

    onSubmitSearchForm(onSearchBySearchTerms)(event);

    if (hasFormChanged) {
      setFocusOnNextView();
      setHasFormChanged(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CustomText as={Text} text={messageSearchForm} />
      {formFields.map((formField) => {
        const { label, name, value, error, tooltip, placeholder } = formField;

        return (
          <Input
            key={`input-${name}`}
            name={name}
            value={value}
            label={label}
            error={t(error)}
            onChange={handleChange}
            required
            labelTooltip={tooltip}
            placeholder={placeholder}
          />
        );
      })}
      <Button type="submit">{t('RETRY')}</Button>
    </form>
  );
};

export default RetrySearchForm;
